import { render, staticRenderFns } from "./play-minimal.vue?vue&type=template&id=513090d5&scoped=true&"
import script from "./play-minimal.vue?vue&type=script&lang=js&"
export * from "./play-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513090d5",
  null
  
)

export default component.exports